const ru = {
    "sc_title": "Центр безопасности",
    "sc_subtitle": "Интегрированный уровень безопасности GaiaShield",
    "sc_tab_status": "🛡️ Статус защиты",
    "sc_tab_events": "📋 Журнал безопасности",
    "sc_tab_node": "⚙️ Безопасность узла",
    "sc_loading": "Загрузка данных безопасности...",
    "sc_status_secured": "Статус системы: Учетная запись защищена",
    "sc_status_warning": "Статус системы: Активные предупреждения",
    "sc_desc_secured": "Нет активных критических предупреждений. GaiaShield активно отслеживает вашу учетную запись.",
    "sc_desc_warning": "Внимание: Есть активные события безопасности, требующие вашего внимания.",
    "sc_account_protection": "Защита учетной записи",
    "sc_message_protection": "Защита сообщений",
    "sc_audits": "Аудит безопасности",
    "sc_active": "АКТИВНО",
    "sc_failed_logins": "Неудачные входы",
    "sc_tamper_checks": "Проверка целостности",
    "sc_blocked_replays": "Заблокированные повторы",
    "sc_last_check": "Последняя проверка",
    "sc_just_now": "Только что",
    "sc_open_warnings": "Открытые предупреждения",
    "sc_btn_acknowledge": "Подтвердить",
    "sc_filter_severity": "Важность",
    "sc_filter_category": "Категория",
    "sc_filter_hide_ack": "Скрыть подтвержденные",
    "sc_btn_export": "Экспорт",
    "sc_col_details": "Подробности",
    "sc_col_time": "Время",
    "sc_col_status": "Статус",
    "sc_col_action": "Действие",
    "sc_no_events": "Событий безопасности не найдено.",
    "sc_node_title": "Консоль безопасности оператора узла",
    "sc_system_health": "Здоровье системы",
    "sc_last_audit": "Последний аудит",
    "sc_packed_logs": "Архивированные журналы",
    "sc_unconfirmed_events": "Неподтвержденные события",
    "sc_operator_action": "Требуется действие оператора",
    "sc_all_ok": "Все в порядке",
    "sc_critical_events": "Критические события системы",
    "ac_title": "Центр управления и жалоб",
    "ac_subtitle": "Консенсус управления и жалоб GaiaCom",
    "ac_tab_my_reports": "Мои жалобы",
    "ac_tab_queue": "Очередь проверок",
    "ac_tab_operator": "Оператор узла",
    "ac_tab_transparency": "Федерация и прозрачность",
    "ac_loading": "Загрузка данных...",
    "ac_reported_cases": "Зарегистрированные случаи",
    "ac_no_reports": "Вы еще не отправляли жалоб.",
    "ac_case_details": "Детали дела",
    "ac_appeal_submit": "Подать апелляцию",
    "ac_appeal_status": "Статус апелляции",
    "ac_appeal_reason": "Причина апелляции",
    "ac_appeal_statement": "Заявление",
    "ac_btn_appeal": "Отправить апелляцию",
    "ac_trusted_reviewer_queue": "Очередь доверенных рецензентов",
    "ac_case_review": "Рассмотреть дело",
    "ac_review_category": "Рекомендуемая категория",
    "ac_review_severity": "Рекомендуемая степень тяжести",
    "ac_review_action": "Рекомендуемое действие",
    "ac_review_reason": "Обоснование рецензента",
    "ac_btn_submit_review": "Отправить отзыв",
    "ac_node_operator_dashboard": "Панель оператора узла",
    "ac_apply_action": "Применить действие (Переопределение)",
    "ac_target_type": "Тип цели",
    "ac_target_id": "ID цели (GaiaID или ID канала)",
    "ac_suspend": "Блокировка активна",
    "ac_reason": "Официальная причина",
    "ac_btn_apply": "Применить меру",
    "ac_transparency_title": "Журнал консенсуса и прозрачности",
    "ac_transparency_desc": "Публично просматриваемые доказательства моментальных снимков всех модерируемых каналов и удостоверений.",
    "ac_btn_snapshot": "Создать моментальный снимок прозрачности",
    "search_placeholder": "Поиск писем по теме, отправителю, тексту...",
    "abuse_center_title": "Центр жалоб",
    "abbrechen": "Отмена",
    "active_identities": "Активные личности",
    "active_identity": "Активная личность",
    "add_btn": "Добавлять",
    "add_contact_title": "Добавить контакт",
    "admin": "Админ",
    "adressbuch": "Адресная книга",
    "aktiviert": "Активирован",
    "an": "Кому",
    "anonymous_sender": "Анонимный отправитель",
    "antworten": "Ответить",
    "attachment_gaia_hint": "Вложения GaiaCOM остаются сквозным зашифрованным.",
    "attachment_smtp_hint": "Устаревший SMTP блокирует вложения в виде исполняемых файлов и сценариев и сохраняет электронные письма как небезопасные.",
    "attachments": "Вложения",
    "auffaellig": "Подозрительный",
    "auth_beta_notice": "Бета-тест: GaiaCOM активно проверяется. Возможны ошибки; храните важные seed-фразы в резерве и внимательно проверяйте критичные сценарии.",
    "auth_btn_login": "Загрузить личность и войти",
    "auth_btn_register": "Регистрация и создание ключей",
    "auth_copied": "Скопировано",
    "auth_copy_seed": "Копировать сид",
    "auth_generate_seed": "Сгенерировать сид",
    "auth_headline": "GaiaCOM — первый квантово-стойкий протокол электронной почты и система связи, созданная для человечества.",
    "auth_kicker": "Постквантовая защищенная связь",
    "auth_mnemonic": "Мнемоническая фраза",
    "auth_mnemonic_placeholder": "12 слов, разделенных пробелами...",
    "auth_password": "Пароль",
    "auth_password_placeholder": "••••••••••••",
    "auth_proof_e2ee_desc": "Закрытые ключи никогда не покидают ваше устройство. Расшифровать содержимое могут только предназначенные получатели.",
    "auth_proof_gaiadata_desc": "Zero-Knowledge: вы сохраняете контроль над своими данными. Метаданные минимизируются и не превращаются в открытый профиль.",
    "auth_proof_gaiadrop_desc": "Внешние отправители могут передавать конфиденциальные текстовые сообщения на ваш GaiaID без учетной записи.",
    "auth_proof_gaiaproof_desc": "Доказательства доставки и целостности показывают, что шифротекст, отправитель и временная метка не были изменены.",
    "auth_proof_gaiavault_desc": "Личные заметки, подсказки восстановления и записи безопасности остаются локально зашифрованными.",
    "auth_proof_hybrid_desc": "Quantum Shield: гибридное шифрование ML-KEM и X25519 защищает от современных атак и риска «сохранить сейчас, расшифровать позже».",
    "auth_secure_mail": "Безопасная квантовая федеративная почта",
    "auth_subline": "GaiaCOM — квантово-устойчивая система связи для почты, чатов, кризисных комнат, GaiaDrop и локальных записей безопасности. Закрытые ключи остаются на вашем устройстве, содержимое шифруется сквозным шифрованием, а доказательства можно экспортировать без раскрытия открытого текста.",
    "auth_success_btn": "Войти сейчас",
    "auth_success_text": "Ваш аккаунт GaiaCOM создан. Ключи были созданы локально из вашего сида и не хранятся на сервере.",
    "auth_success_title": "Регистрация успешна",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Вход / аккаунт",
    "auth_toggle_login": "Уже есть аккаунт",
    "auth_toggle_register": "Создать новый аккаунт",
    "auth_usecase_text": "Подходит для юристов, компаний, ведомств, журналистов, информаторов и частных инцидентов безопасности.",
    "auth_usecase_title": "Создано для чувствительной коммуникации",
    "auth_username": "Имя пользователя",
    "auth_username_placeholder": "Введите имя...",
    "auth_value_chat": "E2E-чат",
    "auth_value_drop": "Secure Drop",
    "auth_value_mail": "Защищенная почта",
    "auth_value_rooms": "GaiaRooms",
    "bestaetigen": "Подтверждать",
    "bestaetigt": "Подтверждено",
    "bio_status": "Биография / Статус",
    "biography": "Биография",
    "change_password_desc": "Изменяет ваш пароль для входа на сервере. Ваша локальная резервная фраза остается отдельно защищенной паролем Vault/Unlock.",
    "change_password_menu_desc": "Обновите пароль для входа в GaiaCOM.",
    "change_password_title": "Изменить пароль",
    "channel_id": "Идентификатор канала",
    "channel_name_label": "Название канала",
    "chat_deleted_hidden": "Чат удален и скрыт.",
    "chat_input_placeholder": "Введите безопасное сообщение...",
    "chat_start_hint": "Начните разговор! Все сообщения в чате защищены квантово-безопасным сквозным шифрованием.",
    "choose_avatar": "Выбрать аватар",
    "ciphertext_hash": "Хэш шифртекста",
    "clear_chat": "Пустой чат",
    "clear_for_everyone": "Пусто для всех",
    "clear_for_me": "Пустой только для меня",
    "click_to_write_mail": "Нажмите, чтобы написать письмо",
    "click_top_right": "Нажмите вверху справа на",
    "close": "Закрыть",
    "code_kopieren": "Копировать код",
    "code_kopieren_success": "Код скопирован.",
    "confirm_clear_channel_desc": "Вы хотите удалить этот канал из локального просмотра?",
    "confirm_clear_channel_title": "Пустой канал",
    "confirm_clear_chat": "Вы хотите очистить этот чат?",
    "confirm_clear_chat_desc": "Вы хотите очистить этот чат?",
    "confirm_clear_chat_title": "Пустой чат",
    "confirm_clear_everyone": "Вы хотите очистить этот чат для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    "confirm_delete_everyone": "Вы хотите удалить это сообщение для обеих сторон? (OK = Для всех, Отмена = Только для меня)",
    "confirm_delete_msg": "Вы хотите удалить это сообщение?",
    "confirm_delete_msg_desc": "Вы хотите удалить это сообщение в чате?",
    "confirm_delete_msg_title": "Удалить сообщение",
    "confirm_new_password": "Подтвердить новый пароль",
    "copy": "Копировать",
    "create_btn": "Создавать",
    "create_channel_title": "Создать канал",
    "create_group_is_crisis": "Отметить как кризисную зону",
    "create_group_title": "Создать новую группу",
    "crypto_lock_desc": "Управляет тем, когда GaiaCOM удаляет локальные криптоключи из памяти.",
    "crypto_lock_menu_desc": "Управляйте таймерами перезагрузки и бездействия.",
    "crypto_lock_title": "Криптографический замок",
    "crypto_session_duration": "Разблокируется после перезагрузки",
    "crypto_session_duration_desc": "Криптосессия остается открытой на этой вкладке браузера только в течение выбранного периода.",
    "cryptographic_fingerprint": "Криптографический отпечаток",
    "current_password": "Текущий пароль",
    "data_minimization": "Минимизация данных",
    "decrypt_failed": "Не удается расшифровать",
    "delete": "Удалить",
    "delete_account_button": "Удалить аккаунт безвозвратно",
    "delete_account_confirm_label": "Введите DELETE для подтверждения.",
    "delete_account_confirmation_error": "Требуется пароль и подтверждение DELETE.",
    "delete_account_desc": "Этот режим безвозвратно уничтожает вашу учетную запись, личные данные, сеансы устройства, данные GaiaDrop, загружаемые метаданные и сообщения, связанные с сервером.",
    "delete_account_done_desc": "Все назначаемые данные GaiaCOM были удалены.",
    "delete_account_done_title": "Аккаунт удален",
    "delete_account_menu_desc": "Уничтожить учетную запись и связанные с ней данные.",
    "delete_account_not_authenticated": "Нет активного аккаунта.",
    "delete_account_title": "Удалить аккаунт",
    "delete_for_everyone": "Удалить для всех",
    "delete_for_me": "Удалить только для меня",
    "device_current": "Это устройство",
    "device_last_seen": "Последний",
    "device_logout": "Выйти",
    "device_sessions_desc": "Проверьте активные сеансы и отмените регистрацию устройств, которым вы больше не доверяете.",
    "device_sessions_empty": "Устройства не найдены.",
    "device_sessions_menu_desc": "Управляйте активными сеансами и завершайте их.",
    "device_sessions_title": "Зарегистрированные устройства",
    "device_since": "С",
    "display_name": "Отображаемое имя",
    "drop_address_copied": "Адрес GaiaDrop скопирован.",
    "drop_btn_decrypting": "Дешифрование папки...",
    "drop_btn_load": "Загрузить GaiaDrop Inbox",
    "drop_delete_desc": "Вы действительно хотите навсегда удалить этот дроп?",
    "drop_delete_title": "Удалить GaiaDrop",
    "drop_desc": "Текстовый канал с нулевым разглашением для внешних сообщений, раскрытия уязвимостей и конфиденциальных отчетов. Внешние пользователи могут отправлять сообщения на ваш GaiaID без аккаунта.",
    "drop_empty": "Входящих сообщений GaiaDrop пока нет.",
    "drop_id": "Drop ID:",
    "drop_own_address": "Ваш адрес GaiaDrop",
    "drop_proof": "DROP PROOF",
    "drop_title": "Приемник GaiaDrop Secure Inbox",
    "dunkler_modus": " Тёмная тема",
    "e2e_chat_room_open": "Открыть чат-комнату E2E",
    "edit_profile": "Редактировать профиль",
    "edit_profile_desc": "Настройте отображаемое имя, биографию и аватар.",
    "einladungscode": "Код приглашения",
    "enter_fingerprint_chars_confirm": "Введите запрошенные символы отпечатка пальца для подтверждения.",
    "envelope_hash": "Хэш конверта",
    "erasability": "Возможность удаления",
    "erfolg": "Успех",
    "exclude_plaintext": "Экспорт без обычного текста",
    "export_disclosure": "Экспорт дела безопасности",
    "export_package_desc": "Включайте простой текст только в том случае, если такое раскрытие информации сделано намеренно.",
    "export_package_title": "Экспортный пакет безопасности",
    "fehler": "Ошибка",
    "gaiacom_reader": "GaiaCOM Reader",
    "gaiadrop_inbox_title": "Входящие GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM сводит к минимуму метаданные, хранит закрытые ключи локально, осуществляет сквозное шифрование контента и позволяет полностью удалить учетную запись.",
    "gdpr_home_title": "100% соответствие GDPR",
    "gdpr_reason_delete": "При удалении учетной записи удаляются учетная запись, идентификационные данные, локальные сеансы и данные, назначаемые на стороне сервера.",
    "gdpr_reason_e2ee": "Частный контент остается доступным для расшифровки только для предполагаемых получателей.",
    "gdpr_reason_minimal": "Метаданные используются только для маршрутизации, доставки и учетных данных безопасности.",
    "gdpr_reason_zero_knowledge": "Закрытые ключи и данные для восстановления остаются локально под контролем пользователя.",
    "gesendet": "Отправленные",
    "gesperrt_verdaechtig": "Заблокирован / Подозрительный",
    "group_delete_desc": "Вы действительно хотите навсегда удалить эту группу? Все каналы и сообщения в этой группе будут удалены.",
    "group_delete_title": "Удалить группу",
    "group_description": "Описание",
    "group_icon_label": "Значок группы/аватар",
    "group_name": "Название группы",
    "group_settings_avatar": "Аватар",
    "group_settings_desc": "Описание",
    "group_settings_is_crisis": "Отметить как кризисную зону",
    "group_settings_name": "Название группы",
    "group_settings_title": "Настройки группы",
    "groups_empty_desc": "Создайте защищенное рабочее пространство для проекта, кризисной ситуации или командной коммуникации.",
    "groups_empty_title": "Групповых чатов пока нет",
    "gruppe_beitreten": "Группа присоединена",
    "gruppe_erstellen": "+ Создать группу",
    "gruppe_verlassen": "Выйти из группы",
    "gruppen_chats": "Групповые чаты",
    "heller_modus": " Светлая тема",
    "how_to_receive_drops": "Как получать дропы?",
    "identitaets_assistent": "Помощник личности",
    "inactivity_lock_duration": "Блокировать, когда неактивен",
    "inactivity_lock_duration_desc": "После этого периода отсутствия ввода GaiaCOM автоматически будет криптографически заблокирован.",
    "inactivity_lock_notice": "GaiaCOM был криптографически заблокирован из-за неактивности.",
    "include_plaintext": "Включить простой текст",
    "invite_code_label": "Пригласительный код",
    "join_group_title": "Присоединиться к группе",
    "kanaele": "Каналы",
    "kanal_erstellen": "+ Канал",
    "kein_chat_ausgewaehlt": "Чат не выбран",
    "kein_kanal_ausgewaehlt": "Канал не выбран",
    "keine_gruppe_ausgewaehlt": "Группа не выбрана",
    "keine_mails": "Нет писем.",
    "key_change_warn_desc": "Открытый ключ этого контакта изменился. Проверьте отпечаток пальца, прежде чем доверять ему.",
    "key_change_warn_title": "Криптографическое предупреждение",
    "key_change_warning_changed": "изменилось. Это может быть признаком атаки «человек посередине»!",
    "key_change_warning_msg": "Идентификационный ключ для контакта",
    "key_transparency": "Прозрачность ключей (История ключей)",
    "kopiert": "Скопировано",
    "kryptographische_schluessel": "Криптографические ключи",
    "kryptographische_schluessel_desc": "Показать закрытые ключи и резервную исходную фразу.",
    "laden": "Загрузка...",
    "leeren": "Пустой",
    "loading": "Нагрузка...",
    "local_key_vault": "Локальное хранилище ключей",
    "local_keys_label": "Локальные ключи",
    "lock_on_reload": "Всегда блокировать после перезагрузки",
    "logout": "Выйти",
    "mail_compose": "Написать письмо",
    "mein_profil": "Мой профиль",
    "melden": "Пожаловаться",
    "menu": "Меню",
    "message": "Новости",
    "message_id": "ID сообщения",
    "message_pin": "Приколоть",
    "message_pinned_title": "Закрепленные сообщения",
    "message_react": "Реагировать",
    "message_reply": "Отвечать",
    "message_replying_to": "Ответ на",
    "message_save": "Сохранять",
    "message_saved": "Сохранено",
    "message_to_channel": "Сообщение в",
    "message_unpin": "Решать",
    "message_unsave": "Не сохранять",
    "mitglied": "Участник",
    "mitglieder": "Участники",
    "ml_kem": "МЛ-КЕМ",
    "neue_mail": "Новое письмо",
    "never_auto_lock": "Никогда автоматически",
    "new_fingerprint": "Новый отпечаток пальца",
    "new_identity": "Новая личность",
    "new_password": "Новый пароль",
    "no_description": "Нет описания",
    "no_key_history": "История ключей не записана.",
    "no_specification": "Не указано",
    "old_fingerprint": "Старый отпечаток пальца",
    "open_privacy_imprint": "Открытая информация и защита данных",
    "post_quantum_e2e": "Постквантовый E2E",
    "posteingang": "Входящие",
    "powered_by": "Powered by",
    "privacy_imprint_menu_desc": "Покажите GDPR, защиту данных и юридическое уведомление.",
    "privacy_imprint_profile_desc": "GaiaCOM обрабатывает коммуникационный контент в соответствии с принципами минимизации данных, сквозного шифрования и управления локальными ключами.",
    "privacy_imprint_title": "Защита данных и юридическое уведомление",
    "profil": "Профиль",
    "profile_details": "Детали профиля",
    "profile_settings_hint": "Настройки профиля отображаются на правой панели.",
    "profile_unlock_desc": "По соображениям безопасности вам необходимо ввести свой пароль еще раз, чтобы просмотреть свои закрытые криптографические ключи.",
    "proof_hash": "Хэш подтверждения:",
    "public_drop_desc": "Secure Drop для внешних текстовых обращений без аккаунта GaiaCOM.",
    "public_drop_message": "Сообщение",
    "public_drop_message_placeholder": "Введите конфиденциальный текст...",
    "public_drop_send": "Отправить GaiaDrop",
    "public_drop_sender": "Заметка отправителя, необязательно",
    "public_drop_sender_placeholder": "Имя, номер дела или анонимно",
    "public_drop_target": "Целевой GaiaID",
    "quanten_chat": "Квантовый чат",
    "quantum_secure_exchange": "Квантово-безопасный обмен через...",
    "quantum_secure_net": "Квантово-безопасная сеть GaiaCOM (Ed25519 и ML-KEM)",
    "quantum_shield_desc": "Сеть GaiaCOM защищает вашу конфиденциальность с помощью многоуровневого гибридного протокола шифрования, устойчивого к атакам будущих квантовых компьютеров.",
    "quantum_shield_l1_desc": "Использует стандарт FIPS 203 для инкапсуляции симметричного общего ключа. Предотвращает пассивный перехват и последующую расшифровку (\\\\\\",
    "quantum_shield_l1_title": "1. Постквантовая защита (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Классический, сверхбыстрый метод обмена ключами Диффи-Хеллмана, служащий дополнительным уровнем безопасности в гибридной схеме.",
    "quantum_shield_l2_title": "2. Эллиптическая криптография (X25519)",
    "quantum_shield_l3_desc": "Каждое сообщение и федеративный конверт подписываются криптографически, чтобы однозначно подтвердить подлинность отправителя.",
    "quantum_shield_l3_title": "3. Цифровые подписи (Ed25519)",
    "quantum_shield_l4_desc": "Шифрует содержимое сообщений симметрично и жестко привязывает отправителя, получателя и метаданные к аутентифицированным дополнительным данным (AAD) для предотвращения атак повторного воспроизведения.",
    "quantum_shield_l4_title": "4. AAD аутентификация (AES-256-GCM)",
    "quantum_shield_status": " Статус Quantum Shield",
    "receive_drops_step1": "Поделитесь вашим GaiaID (например, скопировав его выше) с внешними источниками.",
    "receive_drops_step2": "Они открывают страницу входа вашего инстанса GaiaCOM, переходят на вкладку",
    "receive_drops_step3": "и отправляют свое зашифрованное сообщение на ваш адрес.",
    "receiver_gaia": "приемник GaiaCOM",
    "receiver_smtp": "SMTP-получатель",
    "records_stored": "Записи сохранены",
    "refresh": "Обновлять",
    "report_abuse_desc": "Хотите сообщить об этом сообщении и отправить на сервер криптографические доказательства злоупотреблений?",
    "report_abuse_title": "Сообщить о нарушении",
    "reputation_status": "Статус репутации",
    "room_chat_start_hint": "Начните беседу! Все сообщения в этом групповом канале децентрализованы и защищены сквозным квантово-безопасным шифрованием.",
    "room_policy_audit": "Контрольный журнал и ротация ключей активны.",
    "room_policy_crisis": "Кризисная комната",
    "room_policy_e2ee": "Пространство нулевого знания. Квантовый сейф E2EE.",
    "room_policy_title": "Рекомендации по выбору номера",
    "room_policy_zero_knowledge": "Политика",
    "room_security_note_desc": "Все ключевые изменения проверяются с помощью Key Transparency. Используйте GaiaVault для частных журналов резервного копирования.",
    "room_security_note_title": "Закрепленное примечание по безопасности",
    "save_profile": "Сохранить профиль",
    "schluessel_entsperrt": "🔑 Снова заблокировать ключи",
    "search_gaia_label": "Найти адрес Гайи",
    "security_warning_title": "Предупреждение безопасности",
    "select_channel_chat": "Выберите канал в левой боковой панели, чтобы начать чат.",
    "select_contact_chat": "Выберите контакт на левой панели, чтобы начать безопасный квантово-защищенный чат E2E.",
    "select_mail_read": "Выберите письмо из списка, чтобы прочитать его квантово-безопасное содержимое, или создайте новое сообщение.",
    "senden": "Отправить",
    "sender_signature": "Подпись отправителя",
    "server_log": "Лог сервера:",
    "server_received": "Получено сервером",
    "session_lock": "Блокировка сеанса",
    "setup_address_keys": "Создать адрес и набор ключей",
    "setup_profile": "Настроить в профиле",
    "smtp_inbox_title": "SMTP-прием",
    "smtp_legacy_badge": "Устаревший SMTP/небезопасный",
    "smtp_mode_option": "Устаревший SMTP-мост",
    "smtp_security_warning": "Это письмо было передано по классическому незашифрованному протоколу SMTP. Сквозное шифрование неактивно.",
    "smtp_security_warning_desc": "Это сообщение покидает комнату безопасности GaiaCom. Доставка SMTP не обеспечивает встроенную сквозную гарантию GaiaCom, гарантию TrustMesh и гарантию Godmode со стороны шлюза.",
    "spam_verdacht": "Спам/Подозрение",
    "spam_warning_desc": "Это сообщение содержит подозрительные сигналы репутации.",
    "spam_warning_title": "Предупреждение о спаме",
    "speichern": "Сохранить",
    "sperren": "Заблокировать",
    "standard_group_status": "Стандартный групповой чат (с шифрованием E2EE)",
    "status": "статус",
    "subject": "Касательно",
    "suchen": "Поиск адреса Gaia...",
    "tage": "дней",
    "time_unknown": "Время неизвестно",
    "transmission_mode": "Режим передачи",
    "trust_age": "Возраст доверия",
    "trust_passport_title": "Доверительный паспорт",
    "unbestaetigt": "Не подтверждено",
    "unknown_sender": "Неизвестный",
    "unlock_btn": "Разблокировать",
    "unlock_btn_profile": "Разблокировать",
    "unlock_desc": "Файл вашего закрытого ключа зашифрован. Введите пароль для загрузки криптографических ключей только в оперативную память.",
    "unlock_logout": "Выйти и закрыть локальные ключи",
    "unlock_title": "Разблокировать личность",
    "untrusted": "Недоверенный",
    "update_password": "Обновить пароль",
    "upload_avatar_btn": "Загрузить изображение (очищенное)",
    "vault_btn_encrypt": "Зашифровать запись",
    "vault_btn_lock": "Заблокировать сейф",
    "vault_btn_unlock": "Разблокировать сейф",
    "vault_copied_success": "Скопировано в буфер обмена",
    "vault_decrypted_content": "Расшифрованный контент",
    "vault_desc": "Локальный зашифрованный сейф для резервных копий восстановления, личных заметок, учетных данных серверов, экстренных контактов, юридических заметок, событий безопасности и частных логов.",
    "vault_empty": "В сейфе пока нет сохраненных записей.",
    "vault_locked_pane_notice": "Сейф заблокирован. Пожалуйста, разблокируйте справа.",
    "vault_new_record": "Новая безопасная запись",
    "vault_pwd_placeholder": "Введите пароль сейфа...",
    "vault_record_body": "Запись контента",
    "vault_record_body_placeholder": "Введите зашифрованное содержимое записи...",
    "vault_record_category": "категория",
    "vault_record_title": "Название записи",
    "vault_record_title_placeholder": "Название записи",
    "vault_title": "Сейф GaiaVault Secure Records",
    "verify_new_fingerprint_hint": "Проверьте новый отпечаток пальца, прежде чем принять ключ.",
    "vertrauenswuerdig": "Доверенный",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "От",
    "warnung": "Предупреждение",
    "wizard_address": "Адрес",
    "wizard_back": "Назад",
    "wizard_check1": "Я надежно сохранил свою сид-фразу.",
    "wizard_custom_domain": "Использовать свой домен",
    "wizard_desc1": "GaiaCOM не хранит закрытые ключи на стороне сервера. Без мнемонического сида никто не сможет восстановить утерянные сообщения.",
    "wizard_desc2": "Ваш адрес определяет федеративный узел, через который маршрутизируются зашифрованные конверты.",
    "wizard_fallback": "Резервные узлы",
    "wizard_finish": "Завершить настройку",
    "wizard_next": "Далее",
    "wizard_server_domain": "Домен узла сервера",
    "wizard_step1": "1. Резервный сид",
    "wizard_step2": "2. Адрес и Сервер",
    "wizard_title1": "Защитить ключи восстановления",
    "wizard_title2": "Выберите адрес GaiaCOM",
    "write_message_placeholder": "Напишите защищенное сообщение...",
    "you": "Ты",
    "zero_knowledge": "Zero Knowledge",
    "zero_knowledge_encryption": "Шифрование с нулевым разглашением",
    "Chat fuer alle geleert": "Чат опустел для всех участников.",
    "Chat geleert": "Чат был удален для вашего локального почтового ящика.",
    "Nachricht fuer alle geloescht": "Сообщение удалено у всех участников.",
    "Nachricht geloescht": "Сообщение чата было локально удалено из вашего почтового ящика.",
    "anpinnen": "Приколоть",
    "chat_loeschen": "Удалить чат",
    "confirm_delete_chat_desc": "Вы уверены, что хотите удалить и скрыть чат?",
    "confirm_leave_group_desc": "Вы действительно хотите покинуть эту группу?",
    "entpinnen": "Открепить",
    "group_deleted": "Группа успешно удалена.",
    "group_left": "Успешно покиньте группу.",
    "gruppe_loeschen": "Удалить группу",
    "loeschen": "Удалить",
    "no_active_chats": "Нет активных чатов. Найдите контакты выше, чтобы начать чат.",
    "pinned": "Закреплено",
    "wizard_check_credentials": "Я несу ответственность за безопасность моих данных доступа.",
    "wizard_check_is_beta": "Я понимаю, что GaiaCom — это бета-версия программного обеспечения.",
    "wizard_check_no_illegal": "Я не буду использовать GaiaCom в незаконных целях.",
    "wizard_check_no_uptime": "Я понимаю, что нет никакой гарантии наличия.",
    "wizard_check_smtp_security": "Я понимаю, что сообщения SMTP не обеспечивают полную безопасность GaiaCom.",
    "wizard_check_terms_read": "Я прочитал Условия использования бета-версии.",
    "wizard_step_terms": "Условия эксплуатации",
    "wizard_terms_text": "Условия использования GaiaCom и соглашение о бета-тестировании (бета-фаза)\n\nПоставщик: VisionGaiaTechnology (далее «Поставщик»)\nСтатус: этап публичного бета-тестирования.\nСрок действия: с 21 июня 2026 г.\n\n⚠️ САМОЕ ВАЖНОЕ ПРИМЕЧАНИЕ ЗАРАНЕЕ (ПОЖАЛУЙСТА, ПРОЧИТАЙТЕ ВНИМАТЕЛЬНО)\nGaiaCom находится на стадии публичного бета-тестирования. Несмотря на обширные меры безопасности, отсутствие ошибок, постоянная доступность или абсолютная безопасность программного обеспечения и базовой инфраструктуры не могут быть гарантированы. Используйте на свой страх и риск. Пользователи несут ответственность за безопасное хранение своих данных доступа (особенно ключей для GaiaVault) и за соблюдение действующего законодательства.\n\n1. Предмет и цель этапа бета-тестирования\n1.1. Цель предоставления: GaiaCom — это новая служба электронной почты и чата, основанная на постквантовой криптографии (PQC). Положение на этапе бета-тестирования предназначено исключительно для технического тестирования, моделирования нагрузки, поиска программных ошибок (багов) и оптимизации удобства использования.\n1.2. Статус бета-версии: пользователь осознает, что предлагаемое программное обеспечение является предварительной версией (бета-версией). Технически он еще не полностью разработан, не соответствует стандарту конечного коммерческого продукта и может вызвать ошибки, потерю данных, задержки передачи или сбои системы.\n1.3. Отсутствие права на продолжение: Поставщик имеет право в любое время прекратить предоставление услуги полностью или частично, изменить или ограничить функции или удалить их временно или навсегда без объяснения причин.\n\n2. Доступность и отказ от гарантии\n2.1. Нет гарантии доступности: GaiaCom предоставляется без каких-либо гарантий доступности или времени безотказной работы. Право на бесперебойную доступность услуги отсутствует.\n2.2. Исключение гарантии: Программное обеспечение предоставляется в его текущем состоянии («как есть») и при условии его доступности. В пределах, разрешенных законом, любые гарантийные претензии в отношении материальных и юридических дефектов программного обеспечения исключаются. В частности, нет никакой гарантии, что программное обеспечение не содержит ошибок, вредоносных программ или пригодно для определенной цели.\n\n3. Управление рисками и обязательства пользователей\n3.1. Запрет на хранение критически важных данных: Пользователь обязуется не хранить и не передавать исключительно через GaiaCom любые критически важные для бизнеса, жизненно важные, оперативно необходимые или юридически особо конфиденциальные данные (такие как файлы пациентов, высокочувствительные финансовые данные или официально регулируемые секреты). Услугу нельзя использовать для инфраструктуры, где непредвиденные сбои могут привести к травмам, материальному ущербу или значительным финансовым потерям.\n3.2. Самостоятельное резервное копирование: Пользователь несет ответственность за резервное копирование всех данных, полученных или отправленных через GaiaCom, которые ему понадобятся в долгосрочной перспективе, на собственных независимых системах (резервные копии). Провайдер не гарантирует постоянное хранение или возможность восстановления данных на своих серверах.\n\n4. Криптографические функции и GaiaVault\n4.1. Постквантовая криптография (PQC): GaiaCom реализует современные, ориентированные на будущее процессы шифрования, которые предназначены для противостояния атакам будущих квантовых компьютеров. Однако пользователь осознает, что это динамичная и новая научная область. Абсолютная, неопровержимая безопасность не может быть гарантирована на основе современного состояния науки и техники. Такие термины, как «100% безопасность», «невзламываемость» или «военная безопасность», явно не гарантируются.\n4.2. Отсутствие гарантии восстановления (GaiaVault): GaiaCom опирается на последовательную концепцию безопасности с нулевым разглашением данных. Ключи шифрования и данные доступа остаются исключительно под контролем пользователя (защищены с помощью GaiaVault).\nВАЖНО: Если пользователь потеряет свои пароли, кодовые фразы, закрытые ключи или начальные данные для восстановления, у провайдера нет технической возможности восстановить или сбросить эти данные. Утрата этих данных доступа неизбежно приводит к безвозвратной утрате доступа к учетной записи пользователя и всем зашифрованным в ней данным.\n4.3. Еще не прошел полный аудит: программное обеспечение постоянно подвергается внутренним проверкам безопасности, но на момент бета-фазы оно еще не прошло окончательный комплексный внешний аудит безопасности независимыми организациями по тестированию.\n\n5. Интерфейсы, устаревшие протоколы и федерация\n5.1. Примечание по SMTP Bridge: GaiaCom предлагает возможность связи через классические протоколы электронной почты (например, SMTP). Пользователь осознает, что сообщения, выходящие за пределы собственной зоны безопасности GaiaCom (например, при отправке на обычный адрес @gmail.com или @gmx.de), передаются через незашифрованные или сторонние серверы. Гарантии сквозной безопасности GaiaCom применяются лишь в ограниченной степени или не применяются вообще к таким исходящим или входящим извне устаревшим сообщениям.\n5.2. Примечание для федерации. Если GaiaCom работает в федеративной сети, сообщения и данные могут проходить через сторонние серверы. Хотя содержимое сообщений остается защищенным сквозным шифрованием, метаданные (такие как время отправки, IP-адреса задействованных серверов и адреса получателей) могут быть технически видны операторам этих объединенных серверов. Провайдер не имеет никакого влияния на методы защиты данных сторонних операторов серверов в федеративной сети.\n\n6. Допустимое использование и запрещенная деятельность\nПользователь обязуется не использовать сервис ненадлежащим образом или в незаконных целях. В частности, запрещено:\n- Распространение, отправка или размещение вирусов, вредоносных программ, фишингового контента или другого вредоносного программного обеспечения.\n- Использование Сервиса для проведения атак типа «отказ в обслуживании» (DDoS) или нежелательной массовой рассылки (спама).\n- Злоупотребление системой для совершения мошенничества.\n- Распространение или обмен незаконным контентом, в частности изображениями сексуального насилия над детьми (CSAM), террористической пропагандой, призывами к насилию или другим криминально значимым контентом.\n\n7. Система сообщения о злоупотреблениях\n7.1. Сообщение о оскорбительном поведении. Пользователи имеют возможность сообщать об оскорбительных сообщениях или незаконной деятельности через интегрированную систему злоупотреблений.\n7.2. Обработка отчетов. Чтобы обеспечить защиту от неправомерного использования, входящие отчеты могут быть подвергнуты техническому анализу (при сохранении ограничений конфиденциальности и шифрования). Это может привести к временной или постоянной блокировке учетных записей пользователей или IP-адресов в случае доказанных нарушений настоящих условий использования.\n\n8. Ограничение ответственности\n8.1. Стандарт ответственности: Бета-версия программного обеспечения предоставляется бесплатно. Таким образом, в соответствии с правовыми нормами в отношении пожертвований или займов поставщик несет ответственность только за умысл (намеренный ущерб) и грубую небрежность.\n8.2. Исключение ответственности за потерю данных: Ответственность за потерю данных исключается, за исключением случаев, когда потеря была вызвана умышленно или по грубой неосторожности со стороны провайдера и пользователь выполнил свое обязательство по уменьшению ущерба посредством регулярного резервного копирования (за пределами GaiaCom).\n8.3. Юридические ограничения: Вышеуказанные ограничения ответственности не распространяются на причинение вреда жизни, телу или здоровью, а также на ответственность в соответствии с Законом об ответственности за качество продукции.\n\n9. Открытый исходный код\nОпределенные компоненты, библиотеки или клиентские приложения GaiaCom могут лицензироваться по лицензиям с открытым исходным кодом (например, GPL, MIT, Apache). Настоящие условия использования не затрагивают соответствующие условия лицензии этих компонентов, и их можно просмотреть в соответствующих репозиториях исходного кода.\n\n10. Экспортный контроль и соблюдение требований\nПользователь осознает, что криптографическое программное обеспечение может подлежать строгому экспортному контролю и юридическим ограничениям. Пользователь несет ответственность за то, чтобы использование GaiaCom не нарушало законы, ограничения на импорт/экспорт или правила криптографии своей страны проживания.\n\n11. Уведомление о защите данных (краткая версия для бета-версии)\n11.1. Минимальный сбор данных: в рамках бета-фазы провайдер собирает только те данные, которые абсолютно необходимы для технической эксплуатации, устранения неполадок и дальнейшего развития (например, файлы журналов сервера для диагностики ошибок).\n11.2. Никакого понимания содержимого: благодаря последовательному принципу нулевого разглашения и шифрованию E2E провайдер никогда не имеет доступа к содержимому ваших чатов, электронных писем или ключей, хранящихся в GaiaVault.\n11.3. Подробное заявление о защите данных: подробные правила защиты данных приведены отдельно и также должны быть приняты во внимание пользователем перед регистрацией.\n\n12. Заключительные положения\n12.1. Применимое право: Применяется право Федеративной Республики Германия, за исключением Конвенции ООН о договорах международной купли-продажи товаров.\n12.2. Возможны изменения: поскольку GaiaCom находится в активной разработке, провайдер оставляет за собой право адаптировать эти условия в любое время с эффектом на будущее. Текущая версия доступна в приложении.",
    "wizard_terms_title": "Условия использования GaiaCom и соглашение о бета-тестировании (бета-фаза)",
    "node_operator": "Оператор узла",
    "search_channels": "Поиск каналов...",
    "senior_reviewer": "Старший рецензент",
    "trusted_reviewer": "Доверенный рецензент",
    "active_frequencies": "Активные частоты",
    "connected_rooms": "СОЕДИНЕННЫЕ ПРОСТРАНСТВА",
    "dashboard": "Панель управления",
    "empty_chats": "Активных чатов нет.",
    "empty_messages": "Новых сообщений нет.",
    "encrypted": "Зашифрованный",
    "gaiacom_uplink": "ГАЙАКОМ-АПЛИНК",
    "install_app": "Установить приложение",
    "install_app_desc": "Для быстрого запуска и автономного режима",
    "kommandozentrale_alpha": "Командный центр АЛЬФА",
    "network_online": "СЕТЬ: ОНЛАЙН",
    "new_room": "Новое пространство",
    "no_frequencies_active": "Нет активных частот. Создайте новую комнату, чтобы начать общение.",
    "no_id": "Нет удостоверения личности",
    "open_chats": "Открытые чаты",
    "open_inbox": "Открыть входящие",
    "primary_identity": "ПЕРВИЧНАЯ ИДЕНТИЧНОСТЬ",
    "recent_chats": "Новые чаты",
    "recent_messages": "Последние новости",
    "session_encrypted": "Сеанс зашифрован: {name}",
    "session_secure": "СТАТУС: БЕЗОПАСНЫЙ",
    "system_verlassen": "Система выхода",
    "write_message": "Написать сообщение",
    "onboarding_step_profile": "Профиль",
    "onboarding_step_security": "Защита",
    "onboarding_step_backup": "Резерв",
    "onboarding_step_launch": "Запуск",
    "onboarding_loading_gaia_id": "Загрузка Gaia-ID",
    "onboarding_setup_kicker": "Первоначальная настройка GaiaCom",
    "onboarding_profile_title": "Сделайте GaiaCom своим пространством.",
    "onboarding_profile_desc": "Ваше отображаемое имя и аватар остаются под локальным контролем и могут быть изменены в профиле в любое время.",
    "onboarding_security_title": "Что GaiaCom защищает для вас прямо сейчас.",
    "onboarding_security_desc": "GaiaCom разделяет личность, ключи, сообщения и состояние сети. Здесь вы видите только краткую версию для пользователя.",
    "onboarding_backup_title": "Резервное копирование — это ваш настоящий аварийный выход.",
    "onboarding_backup_desc": "Без данных восстановления никто не сможет восстановить вашу личность. В этом и заключается смысл настоящей сквозной безопасности.",
    "onboarding_launch_title": "Готово. Что вы хотите сделать в первую очередь?",
    "onboarding_launch_desc": "Вы можете начать прямо сейчас или завершить тур и продолжить работу в панели управления.",
    "onboarding_display_name": "Отображаемое имя",
    "onboarding_display_name_placeholder": "Как GaiaCom должен отображать вас?",
    "onboarding_select_avatar": "Выбрать аватар",
    "onboarding_sec_identity_title": "Идентификация",
    "onboarding_sec_identity_desc": "Ваш Gaia-ID — это ваш сетевой якорь. Контакты могут обнаруживать смену ключей.",
    "onboarding_sec_messages_title": "Сообщения",
    "onboarding_sec_messages_desc": "Содержимое расшифровывается локально. Отредактированные сообщения получают новые подписи.",
    "onboarding_sec_network_title": "Сеть",
    "onboarding_sec_network_desc": "Центр безопасности и Центр жалоб делают риски видимыми без глобального бэкдора.",
    "onboarding_sec_transparency_title": "Прозрачность",
    "onboarding_sec_transparency_desc": "Записывает события безопасности в журнал, чтобы предупреждения оставались отслеживаемыми.",
    "onboarding_backup_notice_title": "Важно для обычных пользователей",
    "onboarding_backup_notice_desc": "Сохраняйте данные восстановления отдельно от этого устройства. При утере пароля и бэкапа GaiaCom намеренно остается заблокированным.",
    "onboarding_backup_consent": "Я знаю, что мой бэкап имеет решающее значение для восстановления и смены устройства.",
    "onboarding_inbox_title": "Входящие",
    "onboarding_inbox_desc": "Читать почту и составить первое сообщение.",
    "onboarding_contacts_title": "Контакты",
    "onboarding_contacts_desc": "Проверить первый контакт или начать чат.",
    "onboarding_channels_title": "Каналы",
    "onboarding_channels_desc": "Открывать публичные частоты.",
    "onboarding_security_title_card": "Центр безопасности",
    "onboarding_security_desc_card": "Просмотр статуса GaiaShield.",
    "onboarding_later": "Позже",
    "onboarding_back": "Назад",
    "onboarding_continue": "Продолжить",
    "onboarding_complete_setup": "Завершить настройку",
    "auth_legal_consent": "Я прочитал и согласен с политикой конфиденциальности и условиями использования.",
    "auth_show_terms": "Показать условия использования",
    "auth_recovery_mode": "Режим восстановления",
    "auth_recovery_import_title": "Импорт файла восстановления",
    "auth_recovery_import_desc": "Восстановите свои ключи GaiaCom из защищенного паролем файла резервной копии. После этого мнемоника и имя пользователя будут заполнены автоматически.",
    "auth_recovery_file_pwd_placeholder": "Пароль к файлу восстановления",
    "auth_recovery_local_pwd_placeholder": "Новый пароль разблокировки минимум 12 символов",
    "auth_recovery_importing": "Импорт...",
    "auth_recovery_decrypt": "Расшифровать восстановление",
    "auth_back_to_login": "Назад к логину",
    "auth_terms_title": "Условия использования GaiaCom Beta",
    "auth_terms_close": "Закрыть",
    "auth_cookie_title": "GaiaCOM остается суверенным.",
    "auth_cookie_desc": "Мы используем только технически необходимое локальное хранилище для языка, сессии и безопасности. Никакого отслеживания, рекламных файлов cookie или профилей третьих лиц.",
    "auth_cookie_accept": "Понятно",
    "sc_explainer_title": "Что здесь на самом деле защищено?",
    "sc_explainer_desc": "GaiaShield — это защитный слой между вашей учетной записью, сообщениями и сетью. Он принимает решения не по содержанию, а по техническим рискам: манипуляции, попытки повтора, несанкционированный доступ, подозрительные шаблоны входа и небезопасные переходы через шлюзы.",
    "sc_explainer_identity_desc": "Проверяет аномалии входа, риски сессии и доступ к другим личностям.",
    "sc_explainer_messages_desc": "Обнаруживает шаблоны повторов, манипулируемые пакеты и отсутствие признаков целостности.",
    "sc_explainer_network_desc": "Помечает риски федерации, ограничения скорости и SMTP до того, как доверие будет неверно отображено.",
    "sc_open_security_warnings": "Открытые предупреждения безопасности",
    "sc_opt_all": "Все",
    "sc_opt_low": "Низкий",
    "sc_opt_medium": "Средний",
    "sc_opt_high": "Высокий",
    "sc_opt_critical": "Критический",
    "sc_opt_failed_login": "Неудачный вход",
    "sc_opt_auth_attack": "Атака авторизации",
    "sc_opt_rate_limit": "Лимит запросов",
    "sc_opt_policy_violation": "Нарушение политик",
    "sc_opt_message_replay": "Повтор сообщения",
    "sc_node_security_data_unavailable": "Данные безопасности узла недоступны",
    "sc_total_events": "Всего событий",
    "sc_login_attacks": "Атаки на вход",
    "sc_rate_limits_active": "Активные лимиты",
    "sc_smtp_shield_hits": "Срабатывания SMTP Shield",
    "sc_top_event_categories": "Топ категорий событий",
    "sc_no_entries": "Нет записей.",
    "sc_node_audit_log": "Журнал аудита узла (последние)",
    "sc_no_node_events": "Нет событий узла.",
    "archiv": "Архив",
    "entwuerfe": "Черновики",
    "markiert": "Помеченные",
    "wichtig": "Важные",
    "snoozed": "Отложенные",
    "papierkorb": "Корзина",
    "spam": "Спам",
    "cancel": "Отмена",
    "error": "Ошибка",
    "success": "Успех",
    "kopieren": "Копировать",
    "block_contact": "Блокировать контакт",
    "unblock_contact": "Разблокировать контакт",
    "report_contact": "Пожаловаться на контакт",
    "check_fingerprint": "Проверить отпечаток",
    "export_encrypted": "Экспорт (Зашифровано)",
    "export_gaiaproof": "Экспорт (GaiaProof)",
    "export_password_prompt": "Введите пароль для шифрования экспорта чата:",
    "export_success": "Чат успешно экспортирован и зашифрован.",
    "export_failed": "Экспорт не удался: ",
    "gaiaproof_export_success": "Пакет GaiaProof успешно экспортирован.",
    "gaiaproof_export_failed": "Экспорт GaiaProof не удался: ",
    "export_gaiaproof_confirm": "Вы хотите загрузить пакет GaiaProof со всеми подписями и подтверждениями доставки сервера? Это может занять некоторое время.",
    "group_settings_is_private": "Закрытая комната (без публичного поиска, только по запросу на вступление)",
    "group_settings_read_only": "Режим только для чтения (только владелец и админы могут отправлять сообщения)",
    "group_settings_slow_mode": "Медленный режим (задержка отправки)",
    "gsn_title": "Социальная лента GSN",
    "gsn_node_feed": "Лента узла",
    "gsn_following_feed": "Подписки",
    "gsn_feed_empty": "Сообщения не найдены.",
    "gsn_composer_placeholder": "Что нового в федерации?",
    "gsn_post_btn": "Поделиться",
    "gsn_profile": "Профиль пользователя",
    "gsn_followers": "Подписчики",
    "gsn_following": "Подписки",
    "gsn_bio": "Описание / О себе:",
    "gsn_bio_label": "Описание / О себе",
    "gsn_display_name": "Отображаемое имя",
    "gsn_edit_profile": "Редактировать профиль",
    "gsn_save_profile": "Сохранить",
    "gsn_add_image": "Добавить изображение (Зашифровано)",
    "gsn_add_emoji": "Вставить эмодзи",
    "gsn_avatar_emoji": "Аватар (Эмодзи)",
    "gsn_follow": "Подписаться",
    "gsn_unfollow": "Отписаться",
    "gsn_repost": "Поделиться / Репостнуть",
    "gsn_post_created": "Пост успешно опубликован.",
    "gsn_image_uploaded": "Изображение зашифровано и загружено.",
    "gsn_upload_failed": "Загрузка изображения не удалась: ",
    "gsn_comment_placeholder": "Напишите комментарий...",
    "gsn_delete_confirm_title": "Удалить пост?",
    "gsn_delete_confirm_desc": "Вы уверены, что хотите навсегда удалить этот пост?",
    "gsn_delete_comment_confirm_title": "Удалить комментарий?",
    "gsn_delete_comment_confirm_desc": "Вы уверены, что хотите навсегда удалить этот комментарий?",
    "gsn_report": "Пожаловаться",
    "gsn_report_title": "Пожаловаться на нарушение",
    "gsn_report_category": "Категория",
    "gsn_report_spam": "Спам / Реклама",
    "gsn_report_harassment": "Домогательство / Язык вражды",
    "gsn_report_abuse": "Злоупотребление",
    "gsn_report_illegal": "Незаконный контент",
    "gsn_report_severity": "Серьезность",
    "gsn_report_low": "Низкая",
    "gsn_report_medium": "Средняя",
    "gsn_report_high": "Высокая",
    "gsn_report_comment": "Дополнительный комментарий",
    "gsn_report_submit": "Пожаловаться",
    "gsn_report_submitted": "Жалоба отправлена модераторам.",
    "gsn_report_post": "Пожаловаться на пост",
    "report_group": "Пожаловаться на группу",
    "report_group_reason_prompt": "Введите причину жалобы (опционально):",
    "report_reason_prompt": "Введите причину жалобы (опционально):",
    "report_failed": "Ошибка при жалобе: ",
    "report_success": "Жалоба успешно отправлена.",
    "room_read_only_placeholder": "Только владелец и админы могут писать",
    "read_only_active": "Режим только для чтения",
    "slow_mode_active": "Медленный режим активен",
    "kommandozentrale": "Командный центр",
    "kontakt_blockiert": "Контакт заблокирован",
    "kontakt_freigegeben": "Контакт разблокирован",
    "mailbox_settings_title": "Настройки ящика",
    "mailbox_settings_desc": "Управление подписью, языком, фильтрами.",
    "mic_access_denied": "Доступ к микрофону запрещен: ",
    "no_frequencies_active_desc": "Создайте новую комнату, чтобы начать общение.",
    "key_changed_warning_title": "ПРЕДУПРЕЖДЕНИЕ О БЕЗОПАСНОСТИ:",
    "key_changed_warning_desc": "Ключ идентификации этого отправителя был обновлен или отличается от ранее известного. Подтвердите отпечаток по другому безопасному каналу связи.",
    "sc_col_category": "Категория",
    "search_members": "Поиск участников...",
    "tab_general": "Общие",
    "tab_members": "Участники",
    "tab_requests": "Запросы",
    "tab_invites": "Приглашения",
    "tab_logs": "Логи",
    "auth_why_gaiacom": "Почему GaiaCOM?",
    "auth_why_gaiacom_desc": "Безопасная децентрализованная альтернатива для вашего конфиденциального общения.",
    "auth_self_managed_id": "Самоуправляемый ID",
    "auth_self_managed_id_desc": "Мгновенно создавайте безопасные криптографические идентификаторы без указания почты или телефона.",
    "auth_gaiadrop_secure_exchange": "Безопасный обмен без аккаунта",
    "auth_gaiadrop_benefit_e2ee": "Сквозное шифрование",
    "auth_gaiadrop_benefit_no_login": "Вход не требуется",
    "auth_gaiadrop_benefit_inbox": "Прямая доставка в почтовый ящик получателя",
    "auth_terms_of_use": "Условия использования",
    "auth_terms_of_use_show": "Показать условия использования",
    "auth_consent_privacy_terms": "Я прочитал и согласен с политикой конфиденциальности и условиями использования.",
    "auth_recovery_import_file": "Импортировать файл восстановления",
    "auth_recovery_password": "Пароль файла восстановления",
    "auth_recovery_local_password": "Новый локальный пароль разблокировки минимум 12 символов",
    "auth_recovery_decrypting": "Расшифровка восстановления...",
    "auth_recovery_back": "Назад к входу",
    "auth_cookie_sovereign": "GaiaCOM остается суверенным.",
    "auth_cookie_sovereign_desc": "Мы используем только технически необходимые функции локального хранилища для языка, сеанса и безопасности. Без отслеживания, без рекламных файлов cookie, без профилей третьих лиц.",
    "auth_cookie_sovereign_accept": "Понятно",
    "unlock_keyboard_toggle": "⌨️ Использовать клавиатуру",
    "unlock_keypad_toggle": "🔢 Использовать PIN-пад",
    "unlock_status_denied": "ДОСТУП ЗАПРЕЩЕН / ПОВТОРИТЕ",
    "unlock_status_decrypting": "РАСШИФРОВКА ХРАНИЛИЩА...",
    "unlock_status_secured": "ХРАНИЛИЩЕ ЗАЩИЩЕНО / ЗАБЛОКИРОВАНО",
    "auth_landing_nav_legal": "Юридические Документы",
    "auth_landing_nav_beta": "Бета-Тестирование",
    "auth_landing_card1_title": "Постквантовое Шифрование (ML-KEM)",
    "auth_landing_card2_title": "100% Децентрализация",
    "auth_landing_card3_title": "Zero-Knowledge",
    "auth_landing_card4_title": "Защита Метаданных",
    "auth_landing_card5_title": "Самоуправляемый ID",
    "auth_landing_hybrid_title": "Современная криптография плюс защита от угроз завтрашнего дня.",
    "auth_landing_hybrid_desc": "GaiaCom сочетает проверенный временем классический обмен ключами с постквантовым инкапсулированием. Защита в глубину.",
    "auth_landing_x25519_desc": "Быстрый и проверенный обмен ключами на эллиптических кривых для современных устройств.",
    "auth_landing_mlkem_desc": "Постквантовое инкапсулирование для долговременной защиты от дешифрования в будущем.",
    "auth_landing_cycle_title": "Сервер ничего не видит. Сеть передает только белый шум.",
    "auth_landing_step1_title": "Локальное Шифрование",
    "auth_landing_step1_desc": "Сообщение шифруется на устройстве отправителя до того, как попадет в сеть или на сервер.",
    "auth_landing_step2_title": "Передача в Виде Блоба",
    "auth_landing_step2_desc": "Пакет передается как криптографический шум через распределенные узлы или уровни хранения.",
    "auth_landing_step3_title": "Распределенное Хранение",
    "auth_landing_step3_desc": "Нет центрального почтового ящика. Данные фрагментированы, распределены и полностью зашифрованы.",
    "auth_landing_step4_title": "Локальное Дешифрование",
    "auth_landing_step4_desc": "Только приватный ключ получателя может преобразовать полученный блоб обратно в текст.",
    "auth_landing_trinity_title": "Один протокол. Три уровня инфраструктуры.",
    "auth_landing_enterprise_desc": "Для корпораций, юридических фирм, бизнеса и приватного банкинга. Закрытые коммуникации с административным контролем.",
    "auth_landing_enterprise_list1": "Внутренний суверенитет и управление пользователями",
    "auth_landing_enterprise_list2": "Собственный сервер (self-hosted) или управляемый суверенный кластер",
    "auth_landing_enterprise_list3": "Соглашение SLA, техподдержка и премиум-модули",
    "auth_landing_network_desc": "Открытая сеть для цифровой приватности. Без продажи данных, инфраструктура для свободной защищенной связи.",
    "auth_landing_network_list1": "Клиентское приложение с открытым исходным кодом",
    "auth_landing_network_list2": "Федеративные узлы (ноды)",
    "auth_landing_network_list3": "Отсутствие центрального ключа расшифровки",
    "auth_landing_defend_desc": "Специализированная инфраструктура для государственных органов и изолированных сегментов связи.",
    "auth_landing_defend_list1": "Развертывание в изолированных физических сетях (air-gapped)",
    "auth_landing_defend_list2": "Возможность брендирования и аудит исходного кода",
    "auth_landing_defend_list3": "Национальный цифровой суверенитет кластера",
    "auth_landing_gov_title": "Открытый протокол. Коммерческая реализация. Разделение прав.",
    "auth_landing_gov_desc": "GaiaCom разделяет публичный протокол, открытые клиенты и коммерческие решения. Доверие строится на открытости.",
    "auth_landing_price1_desc": "Плата за защиту от ботов при распространении через магазины приложений.",
    "auth_landing_price2_desc": "Бесплатно для пользователей, собирающих приложение из исходного кода самостоятельно.",
    "auth_landing_price3_desc": "Для среднего бизнеса, юридических фирм и конфиденциальных команд.",
    "auth_landing_price4_desc": "Для крупных корпораций, отказоустойчивых кластеров, LDAP и рут-доступа.",
    "auth_landing_license1_desc": "Максимальная прозрачность кода для аудита и сообщества.",
    "auth_landing_license2_desc": "Защита copyleft от присвоения и закрытия кода облачными сервисами.",
    "auth_landing_license3_desc": "LDAP, рут-доступ, аудит безопасности, SLA и бизнес-логика.",
    "auth_landing_final_title": "Коммуникация по модели нулевого доверия.",
    "auth_landing_final_desc": "GaiaCom не просто заменяет email. Он заставляет задуматься, почему конфиденциальные данные все еще лежат на серверах, основанных на технологиях 40-летней давности.",
    "auth_landing_final_note": "Примечание: Страница описывает концепцию и планы развития. Заявленные свойства безопасности должны быть подтверждены аудитом перед запуском."




  };

export default ru;